import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
  static readonly KB_SIZE = 1024;
  static readonly MB_SIZE = 1024 * 1024;
  static readonly GB_SIZE = 1024 * 1024 * 1024;

  constructor() { }

  transform(value?: number) {
    value = value ?? 0;

    if (value >= FileSizePipe.GB_SIZE) {
      return `${Math.round(value / FileSizePipe.GB_SIZE)} GB`;
    }

    if (value >= FileSizePipe.MB_SIZE) {
      return `${Math.round(value / FileSizePipe.MB_SIZE)} MB`;
    }

    if (value >= FileSizePipe.KB_SIZE) {
      return `${Math.round(value / FileSizePipe.KB_SIZE)} kB`;
    }

    return `${value} B`;
  }
}
